export default __webpack_public_path__ + "static/media/BA9.45aa33d4.jpg";